// filo-takip/src/Main.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Navbar from "./components/Navbar";
import PrivateRoute from "./components/PrivateRoute";
import AracListesi from "./pages/AracListesi";
import AracPuantajPage from "./pages/AracPuantajPage";
import VehicleDocManagement from "./pages/VehicleDocManagement";
import VehicleDocUpload from "./pages/VehicleDocUpload";
import FiloAdminPage from "./pages/FiloAdminPage";

const Main = () => {
  const { role, userPermissions } = useAuth();

  const normalizedRole = (role || "").toLocaleLowerCase("tr");
  const isCreator = normalizedRole === "oluşturucu";
  const perms = userPermissions?.filotakip || {};

  const landing = (() => {
    if (isCreator || perms.takip)    return "arac-listesi";
    if (perms.yonetici)              return "belge-yonetimi";
    if (perms.giris)                 return "puantaj";
    return "/secilen-proje";
  })();

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Navigate to={landing} replace />} />

        <Route path="arac-listesi"  element={<PrivateRoute><AracListesi /></PrivateRoute>} />
        <Route path="puantaj"       element={<PrivateRoute><AracPuantajPage /></PrivateRoute>} />
        <Route path="belge-yonetimi" element={<PrivateRoute><VehicleDocManagement /></PrivateRoute>} />
        <Route path="belge-yukleme"  element={<PrivateRoute><VehicleDocUpload /></PrivateRoute>} />
        <Route path="admin"          element={<PrivateRoute><FiloAdminPage /></PrivateRoute>} />

        <Route path="*" element={<Navigate to={landing} replace />} />
      </Routes>
    </>
  );
};

export default Main;
